<div class="admin-template" [class.nav-collapsed]="navCollapsed" [class.nav-peek]="navPeek">
	<nav (mouseenter)="onNavEnter()" (mouseleave)="onNavLeave()">
		<ul>
			<li [ngClass]="{ active: activeLink == 'employers', expanded: employer }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'employers']"><span class="material-symbols-outlined">groups_2</span><span class="nav-label">Employers</span></a>
				<div *ngIf="employer" class="subnav">
					<h4 *ngIf="false">{{ employer.employerName }}</h4>
					<ul>
						<li [ngClass]="{ 'subnav-active': activeSection == 'configure' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'configure']">Configure</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'customizations' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'customizations']">Customizations</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'video-cards' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'video-cards']">Video Cards</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'topic-cards' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'topic-cards']">Topic Cards</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'library' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'library']">Library</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'census-data' }"><a [routerLink]="['/admin', 'employer', employer.employerID, 'census-data']">Census Data</a></li>
					</ul>
				</div>
			</li>
			<li class="expanded" *ngIf="!isSuperAdmin">
				<div class="nav-link"><span class="material-symbols-outlined">groups_2</span><span class="nav-label">Employer</span></div>
				<div class="subnav">
					<ul>
						<li [ngClass]="{ 'subnav-active': activeSection == 'library' }"><a [routerLink]="['/admin', 'employer', superAdminEmployerID, 'library']">Library</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'census-data' }"><a [routerLink]="['/admin', 'employer', superAdminEmployerID, 'census-data']">Census Data</a></li>
					</ul>
				</div>
			</li>
			<li [ngClass]="{ active: activeLink == 'global-cards', expanded: activeLink == 'global-cards' }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'global-cards']"><span class="material-symbols-outlined">cards</span><span class="nav-label">Global Cards</span></a>
				<div class="subnav">
					<ul>
						<li [ngClass]="{ 'subnav-active': activeSection == 'video-cards' }"><a [routerLink]="['/admin', 'global-cards', 'video-cards']">Video Cards</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'topic-cards' }"><a [routerLink]="['/admin', 'global-cards', 'topic-cards']">Text Cards</a></li>
					</ul>
				</div>
			</li>
			<li [ngClass]="{ active: activeLink == 'library' }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'library']"><span class="material-symbols-outlined">library_books</span><span class="nav-label">Library</span></a>
			</li>
			<li [ngClass]="{ active: activeLink == 'campaigns', expanded: activeLink == 'campaigns' }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'campaigns']"><span class="material-symbols-outlined">email</span><span class="nav-label">Campaigns</span></a>
				<div class="subnav">
					<ul>
						<li [ngClass]="{ 'subnav-active': activeSection == 'comm-dashboard' }"><a [routerLink]="['/admin', 'campaigns', 'comm-dashboard']">Dashboard</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'video-cards' }"><a [routerLink]="['/admin', 'campaigns', 'templates']">Templates</a></li>
						<li [ngClass]="{ 'subnav-active': activeSection == 'drip-programs' }"><a [routerLink]="['/admin', 'campaigns', 'drip-programs']">Drip Programs</a></li>
					</ul>
				</div>
			</li>
			<li [ngClass]="{ active: activeLink == 'users' }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'users']"><span class="material-symbols-outlined">group</span><span class="nav-label">Users</span></a>
			</li>
			<li [ngClass]="{ active: activeLink == 'reports' }" *ngIf="isSuperAdmin">
				<a class="nav-link" [routerLink]="['/admin', 'reports']"><span class="material-symbols-outlined">analytics</span><span class="nav-label">Reports</span></a>
			</li>
			<li (click)="logout()" class="logout nav-link"><span class="material-symbols-outlined">logout</span><span class="nav-label">Logout</span></li>
		</ul>
		<button type="button" class="nav-toggle nav-link" (click)="toggleNav()" [title]="navCollapsed ? 'Keep the menu open' : 'Collapse the menu to icons'">
			<span class="material-symbols-outlined">{{ navCollapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</span>
			<span class="nav-label">{{ navCollapsed ? 'Keep open' : 'Collapse' }}</span>
		</button>
	</nav>
	<main>
		<div class="top">
			<h1 *ngIf="pageTitle">
				<a [routerLink]="[backButton.link]" [queryParams]="backButton.queryParams" *ngIf="backButton && isSuperAdmin"><span [title]="backButton.title" class="material-symbols-outlined back-arrow">arrow_back</span></a>
				{{ pageTitle }}
			</h1>
			<div class="actions">
				<ng-container *ngFor="let button of headerButtons">
					<div *ngIf="!button.children" class="button" [ngClass]="button.class" [class.disabled]="button.disabled" (click)="!button.disabled && do(button.callback)">{{ button.text }}</div>
					<div *ngIf="button.children" class="button has-children" [ngClass]="button.class">
						{{ button.text }}
						<div class="child-holder">
							<ul>
								<li *ngFor="let child of button.children" (click)="do(child.callback)">{{ child.text }}</li>
							</ul>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="content">
			<router-outlet></router-outlet>
		</div>
	</main>
</div>
